export default "__VITE_ASSET__ab09181a__"